@if (!isSSOUser) {
  <app-modal [title]="'Authorization'" #modal (onClose)="resetForm()">
    <div>
      <div class="modal-message">{{ message }}</div>
      <form #form="ngForm">
        <app-form-group-input
          class="modal-input"
          data-cy="password-modal-input"
          [errorMessages]="errorMessages"
          type="password"
          name="password"
          placeholder="Password"
          [(ngModel)]="password"
          [required]="true"
        ></app-form-group-input>
        @if (isTfaEnabled) {
          <app-form-group-input
            class="modal-input"
            data-cy="password-modal-tfa-input"
            [errorMessages]="errorMessages"
            type="number"
            name="passCode"
            placeholder="Security code"
            [(ngModel)]="passCode"
            [required]="isTfaEnabled"
          ></app-form-group-input>
        }
      </form>
    </div>
    <div class="modal-footer">
      <button data-cy="password-modal-cancel-button" type="button" class="button me-auto" (click)="closeModal()">Cancel</button>
      <app-loading-button
        data-cy="password-modal-submit-button"
        [disabled]="!!(!password || (isTfaEnabled && !passCode))"
        [isPending]="isPending"
        type="button"
        (onClick)="submitPassword()"
      >
        Submit
      </app-loading-button>
    </div>
  </app-modal>
}

@if (isSSOUser) {
  <app-modal-confirm title="Save Confirmation" confirmText="Confirm" (onConfirm)="submit()" #modal>
    {{ message }}
  </app-modal-confirm>
}
